<script>
  export let params;
  export let currentRoute;
  export let question;
  export let addInitialData;
  export let modifyData;
  export let errors;
  let error = null;

  /* Import packages */
  import Select from "svelte-select";
  import { onMount } from "svelte";

  /* Lauch when select client in Select */
  function handleSelectOption(e) {
    error = null;
    modifyData({
      question_uuid: question.uuid,
      value: e.detail.value
    });
  }

  /* Lauch when creal client in Select */
  function handleClearOption() {
    modifyData({
      question_uuid: question.uuid,
      value: ""
    });
  }

  onMount(async () => {
    addInitialData({
      question_uuid: question.uuid,
      value: ""
    });
  });

  $: if (errors && errors.length > 0) {
    const findError = errors.find(err => err.uuid === question.uuid);

    if (findError) {
      error = findError;
    }
  }
</script>

<style>
  .themed {
    --borderRadius: 0px;
    --height: 50px;
    --border: 1px solid #dae1e3;
    --inputFontSize: 16px;
    --borderFocusColor: #80bdff;
    --placeholderColor: #a9a9a9;
    --listBorderRadius: 0px;
  }
  .invalid {
    width: 100%;
    font-size: 80%;
    color: #dc3545;
    margin-top: 0.25rem;
  }
</style>

<div class="px-4">
  <h3 class="text-3 mb-1">
    {question.description}{question.required ? ' *' : ''}
  </h3>
  {#if 'answers' in question}
    <span class="text-2">
      {#if question.answers[0].question_option}
        {question.answers[0].question_option.value}
      {:else}
        <span class="font-italic">Sin respuesta</span>
      {/if}
    </span>
  {:else}
    <div class="themed">
      <Select
        items={question.options.map(option => {
          return { value: option.uuid, label: option.value };
        })}
        on:select={handleSelectOption}
        on:clear={handleClearOption}
        required={true}
        isSearchable={false}
        hasError={error}
        placeholder="Seleccione una opción" />
      {#if error}
        <div class="invalid">{error.errors}</div>
      {/if}
    </div>
  {/if}

</div>
